import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
const YEAR_IN_REVIEW = 'cosemail/v1/export/end-of-year';
const ROLLUP_ENDPOINT = 'cosemail/v1/statistics/rollup-limit';
export function generateYearInReviewExport() {
  const options = {
    data: {
      exportType: 'PDF'
    }
  };
  return http.post(YEAR_IN_REVIEW, options);
}
export function fetchRollupLimitRequest() {
  const query = {
    portalId: PortalIdParser.get()
  };
  return http.get(ROLLUP_ENDPOINT, {
    query
  });
}